"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const autosave_1 = require("../../../../hooks/autosave");
const TaskPage_1 = require("../../base/TaskPage");
const constants_1 = require("../../../../tasks/constants");
const react_redux_1 = require("react-redux");
const CommissionLegacy_1 = require("./CommissionLegacy");
const selectors_1 = require("../../../../entities/commission/selectors");
const Commission_1 = require("./Commission");
const Spacer_1 = require("../../../components/spacer/Spacer");
exports.default = (props) => {
    var _a;
    const { property, viewState } = (0, autosave_1.useAutoSaveProperty)(props.propertyId);
    const { getState } = (0, react_redux_1.useStore)();
    const commission = getState().data.commission.byCustomer[props.customerId];
    const commissionDeals = getState().data.commissionDeals.byCustomer[props.customerId];
    // Defaulting to old structure defensively
    const usesLegacyCommission = (_a = (0, selectors_1.customerIsLegacyCommission)(getState(), props.customerId)) !== null && _a !== void 0 ? _a : true;
    return (React.createElement(TaskPage_1.TaskPage, { task: constants_1.Tasks.COMMISSION, property: property, viewState: viewState, nameOverride: usesLegacyCommission ? 'Commission' : undefined },
        React.createElement(TaskPage_1.TaskLayout, { width: 50 },
            React.createElement(TaskPage_1.TaskColumn, null,
                usesLegacyCommission ? React.createElement(CommissionLegacy_1.CommissionLegacy, null) : React.createElement(Commission_1.Commission, { commission: commission, deals: commissionDeals }),
                React.createElement(Spacer_1.Spacer, { spacing: 'large' })))));
};
//# sourceMappingURL=CommissionPage.js.map